<mat-accordion>
  @for(license of frm.controls; track license){
  <mat-expansion-panel [expanded]="step === $index" (opened)="setStep($index)">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Licencia {{ license.controls['licenseNumber'].value }}
      </mat-panel-title>
      <mat-panel-description>
        <button
          mat-icon-button
          (click)="addLicense($event)"
          type="button"
          color="accent"
          matTooltip="Añadir nueva licencia"
        >
          <mat-icon svgIcon="plus"></mat-icon>
        </button>

        <button
          mat-icon-button
          color="accent"
          (click)="deleteLicense($index, $event)"
          [disabled]="frm.length <= 1"
          matTooltip="Eliminar esta licencia"
        >
          <mat-icon svgIcon="trash-can"></mat-icon>
        </button>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <t-llevo-edit-license-form [frm]="license"></t-llevo-edit-license-form>

    <mat-action-row>
      <button mat-button (click)="prevStep()" [disabled]="$first">
        Anterior
      </button>
      <button mat-button (click)="nextStep()" [disabled]="$last">
        Siguente
      </button>
    </mat-action-row>
  </mat-expansion-panel>
  }
</mat-accordion>